import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/global.css';
import store from './store';  // 導入 store


const app = createApp(App);
app.use(store);  // 使用 store
app.use(router);
app.mount('#app');
